import { Injectable } from '@angular/core';
import { AccessRightType, ApplicationSettingsType, ObjectTypes } from '@fi-shared/types';
import { fiHasAccessToApplicationType, getObjectTypeNameTextId } from '@fi-shared/utils';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { IExtendSharingModel, IExtendSharingResult } from '@fi-app/components/extend-sharing/extend-sharing';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';

@Injectable()
export class ExtendSharingService {
    constructor(
        private userDataService: FiUserDataService,
        private customerDataService: FiCustomerDataService,
        private fiStateService: FiStateService,
        private fiBackend: FiBackendService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    public hasAccessToExtendSharing() {
        return fiHasAccessToApplicationType(
            ApplicationSettingsType.CoreGlobal,
            AccessRightType.Admin,
            this.userDataService.userData.ModuleAccessRights,
        );
    }

    public openExtendedSharing(objectId: number, objectType: ObjectTypes) {
        this.fiStateService.go(FiStateNames.ExtendSharing.Edit, {
            objectId: objectId,
            objectType: objectType,
        });
    }

    public getExtendedSharingRecommendationDialog(objectType: ObjectTypes) {
        const objectName: string = this.appTextService.get(getObjectTypeNameTextId(objectType)).toLowerCase();

        return this.fiDialogsService.confirm({
            headerText: this.appTextService.get('common.new_object_saved', { '{0}': objectName }),
            messageText: this.appTextService.get('extended_sharing.recommend_dialog_message', {
                '{0}': objectName,
            }),
            headerIconClass: 'fal fa-bookmark BrandedColor',
            isTopCloseButtonShown: true,
            yesButtonText: this.appTextService.get('extended_sharing.go_to_set_up'),
            noButtonText: this.appTextService.get('common.skip'),
            config: {
                panelClass: 'fi-dialog-rounded',
                autoFocus: false,
            },
        });
    }

    public makeExtendSharing(extendSharingModel: IExtendSharingModel) {
        return this.fiBackend.fetchDataPost<void>('Core/AccessRight/MakeExtendSharing', extendSharingModel);
    }

    getExtendSharingSummary(extendSharingModel: IExtendSharingModel) {
        return this.fiBackend.fetchDataPost<IExtendSharingResult[]>(
            'Core/AccessRight/GetExtendSharingSummary',
            extendSharingModel,
        );
    }
}
